import React from "react"
import { Grid, Typography } from "@mui/material"

function TCTitleLabel ({
    variant,
    children,
    style,
    fontSize = 20,
    fontWeight = 30,
    color = "dark"
}) {
    const styles  = {
        fontSize: fontSize, fontWeight: fontWeight,
        ...style,
    }
    return (
        <Typography variant={variant} color={color}
            style={{...styles}}>
            {children}
        </Typography>
    )
}

function TCLabel ({
    variant,
    children,
    style,
    subtitle = false,
    bold = false,
    capitalized = false,
    inheritColor = false,
    overflowLine,
    maxChars = null,
    color = "dark",
    showAlert,
    textAlign
}) {
    const styles  = {
        // fontSize: 14, fontWeight: 30,
        fontSize: subtitle ? 11 : 13, fontWeight: bold ? 500 : 400,
        ...style,
    }
    const sx = overflowLine ? {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitLineClamp: overflowLine,
        WebkitBoxOrient: "vertical",
    } : capitalized ? {
        textTransform: "capitalize"
    } : {}

    let text = String(children);
    if (text.length > maxChars) {
        if (text.split(' ').length > 1) {
            text = text.split(' ')[0];    
            text = text.slice(0, maxChars) + '...';
        } else {
            text = text.slice(0, maxChars) + '...';
        }
    }
    return (
        <>
            <Grid container alignItems={'flex-end'} spacing={1}>
              <Grid item xs={textAlign == 'center' ? 12 : 0}>
                <Typography sx={sx} variant={variant} color={color} style={{...styles}}>
                    {(overflowLine && maxChars) ? text : (maxChars) ? text : children}
                </Typography>
              </Grid>
              <Grid item sx={{pt:'0px !important', pl: '2px !important'}}>
                {showAlert && <TCLabel style={{fontSize: 11, color: '#f44336'}}>{showAlert}</TCLabel>}
              </Grid>
            </Grid>
        </>
    )
}

export {
    TCLabel,
    TCTitleLabel
}